module.exports = __webpack_public_path__ + "static/media/truck.23268c5a.svg";